import useResources from "./use-resources";
import { useMemo } from "react";

export default function useAutoActionsAssociations() {
  const { resources, create, del, axios, mutate, ...rest } = useResources(
    "auto-actions-associations",
  );

  const autoActionsAssociations = useMemo(() => {
    return resources.reduce((actionsByTenants, action) => {
      if (actionsByTenants[action.id_tenant]) {
        actionsByTenants[action.id_tenant].push(action);
      } else {
        actionsByTenants[action.id_tenant] = [action];
      }
      return actionsByTenants;
    }, {});
  }, [resources]);

  function createAutoAction(tenantId, autoAction) {
    return create(autoAction, {
      alternateRootPath: `tenants/${tenantId}/auto-actions`,
    });
  }

  function deleteAutoAction(tenantId, autoActionId) {
    return del(autoActionId, {
      alternateRootPath: `tenants/${tenantId}/auto-actions`,
    });
  }

  async function bulkCreateAutoActions(actions) {
    const { data } = await axios.post("auto-actions-associations/bulk", {
      actions,
    });
    await mutate();
    return data;
  }

  async function bulkDeleteAutoActions(actions) {
    const { data } = await axios.post("auto-actions-associations/bulk-delete", {
      actions,
    });
    await mutate();
    return data;
  }

  return {
    autoActionsAssociations,
    createAutoAction,
    deleteAutoAction,
    bulkCreateAutoActions,
    bulkDeleteAutoActions,
    mutate,
    ...rest,
  };
}
